/* eslint-disable @typescript-eslint/no-explicit-any */
import { post } from '_core/config/api/Api';
import { IFinalResponse, InitApiType } from '_core/types';
import Definitions from '../Definitions';

const definitions = Definitions.PartnerToken;

const callPost = async (params: { type: string }): Promise<IFinalResponse> => {
  const init: InitApiType = {
    body: {
      ...params,
    },
  };
  return post(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};
const call = { post: callPost };
export default { call, definitions };
